module.exports = __webpack_public_path__ + "static/media/question_mark_icon.cea798da.png";